exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-input[data-v-5814a14e]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column}.custom-input label[data-v-5814a14e]{font-size:15px}input[data-v-5814a14e]{padding:10px;border:1px solid rgba(60,60,60,.26);border-radius:8px;font-size:14px;outline:none;text-align:left}.valid[data-v-5814a14e]{border-left-color:#afe9a9}.invalid[data-v-5814a14e],.valid[data-v-5814a14e]{border-left-width:4px}.invalid[data-v-5814a14e]{border-left-color:#ff9790}", ""]);

// exports
